export default __webpack_public_path__ + "static/media/send-payment.4abbbbc9.svg";